import { toJS } from 'mobx'
import { assignGlobal } from '~/global'
import * as models from '~/models'
import * as stores from '~/stores'

assignGlobal({toJS})
assignGlobal(stores)
assignGlobal(models)